export const environment = {
  production: false,
  apiUrl: 'https://api-dev.exportcloud.ca/api',
};
